import moment from 'moment-timezone';

export const getIsButtonEnabled = (data, errors) => {
  if (Object.values(data).some((v) => !v) || Object.values(errors).some((e) => e)) return false;

  return true;
};

export const validateScheduleTime = (datetime, timeZone) => {
  let errMsg = '';

  if (!datetime) {
    errMsg = 'Scheduled time should not be empty';
    return { scheduledTime: errMsg };
  }

  const now = moment.tz(timeZone);
  const target = moment.tz(datetime, 'YYYY-MM-DD HH:mm:ss', timeZone);

  if (target.isBefore(now)) {
    errMsg = 'The scheduled time is in the past. Please select a future time.';
    return { scheduledTime: errMsg };
  }

  const hour = moment(datetime).hour();
  const isOutsideClinicalHours = hour >= 23 || hour < 7;

  if (isOutsideClinicalHours) {
    errMsg = 'Time selected is outside of Clinical Hours (7am-11pm ET)';
  }

  return { scheduledTime: errMsg };
};
